export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11928.b349b81c.jpg";